import * as ga4 from './ga4-handlers';
var eventMapper = {
  'browse-option-click': (_key, data) => ga4.moreBrowseOptionsEvent(data)
};
export default eventMapper;